// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ddc-container[data-v-f01374a2]{background:linear-gradient(.43deg,#d70073 .35%,#f15b41 99.61%)}.ddc-uptogether-logo[data-v-f01374a2]{height:31.4px;width:65.7px;-o-object-fit:contain;object-fit:contain}.ddc-us-bank-logo[data-v-f01374a2]{height:16.5px;width:63.5px;-o-object-fit:contain;object-fit:contain}@media (min-width:1024px){.ddc-us-bank-logo[data-v-f01374a2]{height:25px;width:99px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
